/**
 * Jump To Letters (State Page)
 */
export default function jumpToLetter() {
//   console.log('I am loading - jump-to-letters.js - Start 4');

    const links = document.querySelectorAll('.jump-to__alphabet a'); // Select all links
    const navbarHeight = document.querySelector('.site-header').offsetHeight;
    const marginTop = 740;
    const backToTop = document.querySelector('.back-to-top');

    if (null !== links) {
      links.forEach(function(link) {
          link.addEventListener('click', function(e) {
              e.preventDefault(); // Prevent the default link behavior
              const letterToJump = e.target.textContent.trim();

              // Find the first state that starts with that letter
              const targetElement = document.querySelector(`.state-divider[data-state^="${letterToJump}"]`);

              if (targetElement) {
                  window.scrollTo({ // Perform smooth scrolling
                      top: targetElement.offsetTop + marginTop, // Vertical position of the target element, adjusted by navbar height and marginTop
                      behavior: 'smooth' // Specify that the scroll should be smooth
                  });
              }
          });
      });
    }

    // Animate the scroll at the begining of the page 
    if (null !== backToTop) {
        backToTop.addEventListener('click', function(e) {
            window.scrollTo({top: 0, behavior: 'smooth'});
        });

        // Smooth scroll
        window.onscroll = function() {
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                document.querySelector('.back-to-top').style.display = "block";
            } else {
                document.querySelector('.back-to-top').style.display = "none";
            }
        };
    }
}